<template>
  <b-input
    v-model="form.name"
    :error-messages="getErrorMessages(v$.name)"
    label="Назва"
    placeholder="Введіть назву"
    @blur="v$.name.$touch()" />
  <b-input v-model="form.description" label="Опис" placeholder="Введіть опис" />
</template>
<script>
import { computed, reactive } from 'vue'
import { axios, required, useVuelidate } from '@/plugins'
import { getErrorMessages } from '@/utils/helpers'
import { setSnackbar } from 'best-modules/plugins'
import { clearDirectory } from '@/directory/index.ts'

export default {
  name: 'OrgDirectoryItem',
  props: {
    dialog: { type: Object, required: true },
  },
  methods: { getErrorMessages },
  setup(props) {
    const isUpdate = props.dialog.action === 'update'
    const itemData = props.dialog.dialogData?.itemData
    const entityConfig = props.dialog.dialogData?.entityConfig
    const hasDescription = computed(
      () => entityConfig?.hasDescription !== false
    )

    const form = reactive({
      name: itemData?.name || null,
      description: itemData?.description || null,
    })

    const v$ = useVuelidate({ name: { required } }, form)

    const submit = () => {
      const data = hasDescription.value ? form : { name: form.name }
      const url = isUpdate
        ? entityConfig.urlUpdate(itemData.id)
        : entityConfig.urlCreate()
      return axios({
        url,
        method: isUpdate ? 'put' : 'post',
        data,
      }).then(res => {
        setSnackbar({
          text: `${entityConfig.label} ${isUpdate ? 'оновлено' : 'створено'}`,
        })
        if (entityConfig.directoryName) {
          clearDirectory(entityConfig.directoryName)
        }
        return res.data
      })
    }

    return {
      form,
      v$,
      submit,
      hasDescription,
      validationScope: 'orgDirectoryItem',
    }
  },
}
</script>
